import * as React from 'react';
import { getQueryTableAutomationId, QueryTableAutomationId } from '../Helpers/AutomationIdHelper';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';

export interface HamburgerProps {
    children: any;
    automationId?: string;
    disabled?: boolean;
}

export const HamburgerMenu = ({ children, automationId = `${getQueryTableAutomationId(QueryTableAutomationId.Options)}`, disabled = false }: HamburgerProps) => {
    const ref = React.useRef(null);
    const [visible, setVisible] = React.useState<boolean>(true);
    React.useEffect(() => {
        if (!ref.current)
            return;
        setVisible(ref?.current?.children.length > 0);
    }, [ref.current]);
    return (
        !visible ? <></> :
            <div className="btn-group" role="group">
                <button
                    disabled={disabled}
                    data-automationid={automationId}
                    type="button"
                    className="btn btn-primary btn-xs dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <FontAwesomeIcon aria-hidden="true" icon={faBars} />
                </button>
                <ul className="dropdown-menu scrollable-menu pull-right" role="menu" ref={ref}>
                    {children}
                </ul>
            </div>
    );
}



